import Client from './Clients/ScrapingToolsClient'
import RepoUtils from './RepoUtils'

const resource = '/catalog/domain/'
const detailResource = '/catalog/domain_detail/'
const tableResource = '/catalog/domain_table/'
const bodyTypeResource = '/catalog/body_types/'

var bodyTypeCache=null

export default {
    get(){
        return Client.get(detailResource);
    },
    get(id){
        return Client.get(`${detailResource}?id=${id}`);
    },
    getTable(pageNumber,filters){
        filters.page=pageNumber;
        // filters.is_active= filters.is_active===undefined || filters.is_active ? 'True' : 'False';
        return Client.get(RepoUtils.parseResourceWithQueryParams(tableResource,filters));
    },
    post(payload){
        
        return Client.post(resource,payload);
    },
    put(id,payload){
        return Client.put(resource+id+'/',payload);
    },
    getBodyTypes(){
        if(bodyTypeCache===null){
            return Client.get(bodyTypeResource).then((response) => {
                bodyTypeCache=response;
                return new Promise((resolve,reject) => resolve(response));
            })
        }
        else
            return new Promise((resolve,reject) => resolve(bodyTypeCache));
    }
}